import { render, staticRenderFns } from "./RoleMgmt.vue?vue&type=template&id=c18c3080&scoped=true"
import script from "./RoleMgmt.vue?vue&type=script&lang=js"
export * from "./RoleMgmt.vue?vue&type=script&lang=js"
import style0 from "./RoleMgmt.vue?vue&type=style&index=0&id=c18c3080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18c3080",
  null
  
)

export default component.exports